export default __webpack_public_path__ + "static/media/blog-HOA-pavers-002.8cfbdff0.jpg";